import { SelectOption } from '@dtx-company/shared-components/src'
// Sources for labels
// https://greenwichmeantime.com/time-zone/abbreviations/
// https://publib.boulder.ibm.com/tividd/td/TWS/SC32-1274-02/en_US/HTML/SRF_mst273.htm
export const tzOptions = [
  { label: 'MIT', value: 'Etc/GMT+11' },
  { label: 'HST', value: 'Etc/GMT+10' },
  { label: 'AST', value: 'Etc/GMT+9' },
  { label: 'PST', value: 'America/Los_Angeles' },
  { label: 'MST', value: 'America/Denver' },
  { label: 'CST', value: 'America/Chicago' },
  { label: 'EST', value: 'America/New_York' },
  { label: 'IET', value: 'Etc/GMT+4' },
  { label: 'AGT', value: 'Etc/GMT+3' },
  { label: 'BET', value: 'Etc/GMT+3' },
  { label: 'GST', value: 'Etc/GMT+2' },
  { label: 'CAT', value: 'Etc/GMT+1' },
  { label: 'GMT', value: 'Europe/London' },
  { label: 'UTC', value: 'Europe/London' },
  { label: 'ANAT', value: 'Etc/GMT+12' },
  { label: 'CET', value: 'Europe/Berlin' },
  { label: 'EET', value: 'Etc/GMT-2' },
  { label: 'ART', value: 'Etc/GMT-2' },
  { label: 'EAT', value: 'Etc/GMT-3' },
  { label: 'MET', value: 'Etc/GMT-3' },
  { label: 'NET', value: 'Etc/GMT-4' },
  { label: 'PLT', value: 'Etc/GMT-5' },
  { label: 'IST', value: 'Asia/Colombo' },
  { label: 'GMT', value: 'Asia/Kathmandu' },
  { label: 'BST', value: 'Etc/GMT-6' },
  { label: 'CCT', value: 'Indian/Cocos' },
  { label: 'VST', value: 'Etc/GMT-7' },
  { label: 'CTT', value: 'Etc/GMT-8' },
  { label: 'JST', value: 'Etc/GMT-9' },
  { label: 'ACT', value: 'Pacific/Marquesas' },
  { label: 'AET', value: 'Etc/GMT-10' },
  { label: 'SST', value: 'Etc/GMT-11' },
  { label: 'NST', value: 'Etc/GMT-12' },
  { label: 'NZDT', value: 'Etc/GMT-13' }
]

export const SCANNER_TZ = 'Scanner Time'

// The redirect server can not handle offsets which are not whole hours i.e. Etc/GMT-6:30
const isRedirectCompatible = (s: string): boolean => {
  const arr = s.split(/[-+]/)
  return !(arr.length > 1 && arr[1].length > 2)
}

export const RedirectCompatibleTimeZoneOptions: SelectOption[] = [
  { label: SCANNER_TZ, value: SCANNER_TZ }
].concat(tzOptions.filter(option => isRedirectCompatible(option.value)))
